<template>
  <div class="form-wrap">
    <StudentInfoForm
      :student-data="addForm"
      :submit-btn-text="submitBtnText"
      @save="saveHandler"
    />
  </div>
</template>

<script>
import bus from "common/bus";
import { oneApi } from "config/api";
import StudentInfoForm from "components/myAccount/StudentInfoForm/index.vue";

export default {
  components: {
    StudentInfoForm,
  },
  props: {
    studentInfo: {
      type: Array,
    },
    isAppli: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      submitBtnText: this.$t("login.switchStudent.addStudent"),
      addForm: {
        nickName: "",
        firstName: "",
        lastName: "",
        gradeId: "",
        email: "",
      },
    };
  },
  computed: {
    selectedGrade() {
      return this.$store.state.courses.selectedGrade;
    },
    masterUserInfo() {
      return this.$store.state.ucenter.masterUserData;
    },
  },
  async mounted() {
    this.resetData();
    if (this.studentInfo && this.studentInfo.length > 0 && !this.isAppli) {
      this.studentInfo.forEach((e) => {
        if (e.key == "givenName") {
          this.addForm.firstName = e.value;
        }
        if (e.key == "familyName") {
          this.addForm.lastName = e.value;
        }
        if (e.key == "gradeId") {
          this.addForm.gradeId = Number(e.value);
        }
        if (e.key == "nickName") {
          this.addForm.nickName = e.value;
        }
        if (e.key == "email") {
          this.addForm.email = e.value;
        }
      });
    }
    await this.init();
    this.initForm();
  },
  methods: {
    async init() {
      this.isLoading = true;
      if (!this.masterUserInfo.email) {
        await this.getUserInfo();
      }
    },
    resetData() {
      this.addForm.nickName = "";
      this.addForm.firstName = "";
      this.addForm.lastName = "";
      this.addForm.gradeId = "";
      this.addForm.email = "";
    },
    initForm() {
      const { email } = this.masterUserInfo;
      this.addForm.email = email;
    },
    async getUserInfo() {
      const res = await this.$axios.post(
        oneApi.queryMasterUserInfo,
        {},
        { rewritePostBody: true }
      );

      if (Number(res.code) !== 0) {
        this.$ElMessage.error(res.msg);
        this.initLoading = false;
        return;
      }
      this.$store.commit("ucenter/SET_MASTER_USER", res.data);
    },
    saveHandler(newData) {
      this.addForm = Object.assign(this.addForm, newData);
      this.confirmEdit();
    },
    async confirmEdit() {
      const params = {
        nickName: this.addForm.nickName,
        firstName: this.addForm.firstName,
        lastName: this.addForm.lastName,
        gradeId: this.addForm.gradeId,
        email: this.addForm.email,
        sourceCode: "sibling",
        mediaCode: "sibling",
      };
      const res = await this.$axios.post(oneApi.addNewStudent, params, {
        rewritePostBody: true,
      });

      if (Number(res.code) !== 0) {
        this.$ElMessage.error({
          message:
            (res && res.msg) || "Failed to add student, please try again",
          customClass: "el-message-toast",
        });
        return;
      }

      this.$ElMessage.success({ message: this.$t('featureComponents.page.tips.addSuccess'), customClass: 'el-message-toast' });

      this.resetData();

      const resData = res.data || {};

      this.$emit("add-success", resData.id);
      bus.$emit("switchStudent.refresh", resData.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-wrap {
  padding: 14px 45px 20px;
  width: 512px;
}
</style>
